import './styles.scss'
import React, { useState, useEffect } from 'react'
import { I18n } from 'react-redux-i18n'

import ModalWrapper from 'components/ModalWrapper'
import InputControls from 'components/common/InputControls'
import { languages } from 'utils/languages'
import { lang } from 'utils/helpers'

const TranslationConfigModal = ({ isOpen, toggle, consoleId, translationLanguages, updateBotHeader }) => {
  const [translationLanguagesFiltered, setTranslationLanguagesFiltered] = useState(languages)
  const [searchLanguageValue, setSearchLanguageValue] = useState('')
  const [translationLanguagesValues, setTranslationLanguagesValues] = useState(translationLanguages || [])
  const [allSelectedValues, setAllSelectedValues] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (error) setError(null)

    const filteredLanguages = languages.filter(language => {
      return language.value.toLowerCase().includes(searchLanguageValue.toLowerCase()) || I18n.t(language.label).toLowerCase().includes(searchLanguageValue.toLowerCase())
    })
    setTranslationLanguagesFiltered(filteredLanguages)
  }, [searchLanguageValue])

  const handleSave = async () => {
    if (error) setError(null)
    setIsSubmitting(true)

    if (!translationLanguagesValues.length) {
      setError('va_translation-languages_select-least-one')
      setIsSubmitting(false)
      return
    }

    try {
      await updateBotHeader(consoleId, { translationLanguages: translationLanguagesValues })
      setIsSubmitting(false)
      setTimeout(toggle)
    } catch (error) {
      setIsSubmitting(false)
      setError('dashboard_error_save_configuration')
    }
  }

  return (
    <ModalWrapper
      id='translationConfigModal'
      isOpen={isOpen}
      toggle={toggle}
      header={I18n.t('dashboard_languages')}
      body={
        <div className='translation-config-modal-container'>
          <div className='translation-config-modal'>
            <div className='translation-config-modal__search-container'>
              <i className='fa fa-search' aria-hidden='true'></i>
              <input
                type='text'
                placeholder={`${lang('dashboard_search')}...`}
                value={searchLanguageValue}
                onChange={event => setSearchLanguageValue(event.target.value)}
              />
              {searchLanguageValue && (
                <i className='fa fa-times' aria-hidden='true' onClick={() => setSearchLanguageValue('')}></i>
              )}
            </div>
            <ul className='translation-config-modal__languages-list'>
              {translationLanguagesFiltered.length > 1 && (
                <InputControls
                  injectType='external'
                  type='checkbox'
                  label={!allSelectedValues ? I18n.t('dashboard_select_all') : I18n.t('dashboard_deselect_all')}
                  value={allSelectedValues}
                  onChange={value => {
                    if (error) setError(null)
                    setAllSelectedValues(value)
                    if (value) {
                      const selectedValues = []
                      languages.forEach(language => selectedValues.push(language.value))
                      setTranslationLanguagesValues(selectedValues)
                    } else {
                      setTranslationLanguagesValues([])
                    }
                  }}
                />
              )}
              {translationLanguagesFiltered.map((language, index) => (
                <li key={index} className='translation-config-modal__language'>
                  <InputControls
                    injectType='external'
                    type='checkbox'
                    label={I18n.t(language.label)}
                    value={translationLanguagesValues.includes(language.value)}
                    onChange={value => {
                      if (error) setError(null)
                      const newTranslationLanguagesValues = [...translationLanguagesValues]
                      if (value) {
                        newTranslationLanguagesValues.push(language.value)
                        setTranslationLanguagesValues(newTranslationLanguagesValues)
                        if (languages.length === newTranslationLanguagesValues.length && !allSelectedValues) setAllSelectedValues(true)
                      } else {
                        const languageIndex = translationLanguagesValues.findIndex(translationLanguage => translationLanguage === language.value)
                        newTranslationLanguagesValues.splice(languageIndex, 1)
                        setTranslationLanguagesValues(newTranslationLanguagesValues)
                        if (languages.length !== newTranslationLanguagesValues.length && allSelectedValues) setAllSelectedValues(false)
                      }
                    }}
                  />
                </li>
              ))}
            </ul>
          </div>
          {error && <p className='translation-config-modal__error-message'>{I18n.t(error)}</p>}
        </div>
      }
      eventBtnTxt={I18n.t('dashboard_save')}
      eventBtn={handleSave}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
      cancelBtn={toggle}
      isSubmitting={isSubmitting}
    />
  )
}

export default TranslationConfigModal
